/** Angular Imports */
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Button } from '@ntv360/component-pantry';

/**
 * Public landing page shown when an authentication flow is rate-limited or
 * blocked by Auth0 (e.g. repeated MFA email-challenge attempts returning 429).
 *
 * @remarks
 * Reached via `/block`. No guards — the user is unauthenticated by definition
 * when they land here. The "Back to Sign In" button restarts the Auth0 flow
 * via {@link Router}.
 */
@Component({
    selector: 'app-auth-block',
    standalone: true,
    imports: [Button],
    templateUrl: './block.component.html',
    styleUrl: './block.component.scss',
})
export class BlockComponent {
    /** Router used to send the user back to the login page on retry. */
    private readonly _router = inject(Router);

    /** Navigates back to the login page so the user can retry the auth flow. */
    public backToLogin(): void {
        this._router.navigate(['/login']);
    }
}
